import {
  getCopyWithContentTableColumn,
} from '@/utils/common/tableColumn'
import { numerify } from '@/filters'
import i18n from '@/locales'

export default {
  created () {
    this.columns = [
      getCopyWithContentTableColumn({
        field: 'id',
        title: i18n.t('scope.text_678'),
      }),
      {
        field: 'type',
        title: i18n.t('scope.text_679'),
        minWidth: 120,
        formatter: ({ cellValue }) => {
          const obj = {
            exchange: i18n.t('scope.text_680'),
            bill: i18n.t('scope.text_681'),
            refund: i18n.t('scope.text_682'),
            alipay: i18n.t('scope.alipay'),
            tenpay: i18n.t('scope.wechat_pay'),
            payment: i18n.t('scope.transaction.payment'),
            offline: i18n.t('scope.text_685'),
            revoke: i18n.t('scope.text_459'),
            transfer: i18n.t('scope.text_686'),
          }
          return obj[cellValue]
        },
      },
      {
        field: 'is_income',
        title: i18n.t('scope.text_687'),
        minWidth: 120,
        formatter: ({ row }) => {
          return row.is_income ? i18n.t('scope.text_688') : i18n.t('scope.text_689')
        },
      },
      {
        field: 'amount',
        title: i18n.t('scope.text_647'),
        minWidth: 120,
        slots: {
          default: ({ row }, h) => {
            return [
              <div style={{ color: row.is_income ? '#3f8600' : '#cf1322' }}>
                <a-icon type={ row.is_income ? 'arrow-up' : 'arrow-down' } />
                <span>{numerify(row.amount, '0,0.00')}</span>
              </div>,
            ]
          },
        },
      },
      {
        field: 'currency',
        title: i18n.t('scope.text_420'),
        minWidth: 80,
      },
      {
        field: 'balance',
        title: i18n.t('scope.text_577'),
        minWidth: 70,
        formatter: ({ cellValue }) => {
          return numerify(cellValue, '0,0.00')
        },
      },
      {
        title: i18n.t('scope.text_512'),
        field: 'notes',
      },
    ]
  },
}
